import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-lightshow-torch-instructions',
    templateUrl: './lightshow-torch-instructions.component.html',
    styleUrls: [
        './lightshow-torch-instructions.component.css',
    ]
})
export class LightshowTorchInstructionsComponent {
    showInstructions = false;

    constructor() {

    }
}
